import { ScheduleKind, ScheduleRule } from './schedule.rule';

const SCHEDULE_KINDS: readonly ScheduleKind[] = ['perVisit', 'calendar', 'afterService', 'dates'];

/**
 * The schedule a task actually runs on: its own rule, or `undefined` for the working-day default.
 *
 * A stored rule the engine cannot evaluate — no `kind` (a Mongoose subdocument saved as `{ _id }`), an
 * unknown kind, a legacy `scheduleMode` document, or a kind missing its own payload — IS the default,
 * because the task never chose anything else. Evaluated raw it compiled to no class and expanded to no
 * dates, so the task silently vanished from every forecast while the editor showed "every working day".
 *
 * Only broken shapes fold. `{ kind: 'perVisit', perVisit: { nth: 1 } }` is a real choice (a tack-on that
 * creates no dates) and folding it would silently turn it into a daily task.
 */
export function effectiveScheduleRule(value: ScheduleRule | null | undefined): ScheduleRule | undefined {

    if (!value || typeof value !== 'object') return undefined;
    if ('scheduleMode' in value) return undefined;
    if (!SCHEDULE_KINDS.includes(value.kind)) return undefined;

    if (value.kind === 'perVisit' && !value.perVisit) return undefined;
    if (value.kind === 'calendar' && !value.calendar) return undefined;
    if (value.kind === 'afterService' && !value.afterService) return undefined;
    if (value.kind === 'dates' && !value.dates) return undefined;

    return value;
}
